import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useState } from 'react'
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'
import Outline from './components/Outline'
import SearchModal from './components/SearchModal'
import Footer from './components/Footer'

// Page imports
import Studio21Home from './pages/Studio21Home'
import Home from './pages/Home'
import GettingStartedIndex from './pages/GettingStartedIndex'
import Installation from './pages/getting-started/Installation'
import InitialConfiguration from './pages/getting-started/InitialConfiguration'
import InEditorTesting from './pages/getting-started/InEditorTesting'
import InGameTesting from './pages/getting-started/InGameTesting'
import CoreConcepts from './pages/CoreConcepts'
import CsvGeneration from './pages/core-concepts/CsvGeneration'
import Advanced from './pages/Advanced'
import VideoTutorials from './pages/VideoTutorials'
import GettingStartedVideo from './pages/video-tutorials/GettingStartedVideo'
import ExampleFragments from './pages/video-tutorials/ExampleFragments'

import './App.css'

function App() {
  const [searchOpen, setSearchOpen] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(true)

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen)

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Studio21Home />} />
        <Route path="/plugins/VariableModding/*" element={
          <div className="app">
            <Navbar onSearchOpen={() => setSearchOpen(true)} onSidebarToggle={toggleSidebar} />
            <div className="app-layout">
              <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
              <main className="main-content">
                <div className="content-wrapper">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/getting-started" element={<GettingStartedIndex />} />
                    <Route path="/getting-started/installation" element={<Installation />} />
                    <Route path="/getting-started/initial-configuration" element={<InitialConfiguration />} />
                    <Route path="/getting-started/in-editor-testing" element={<InEditorTesting />} />
                    <Route path="/getting-started/in-game-testing" element={<InGameTesting />} />
                    <Route path="/core-concepts" element={<CoreConcepts />} />
                    <Route path="/core-concepts/csv-generation" element={<CsvGeneration />} />
                    <Route path="/advanced" element={<Advanced />} />
                    <Route path="/video-tutorials" element={<VideoTutorials />} />
                    <Route path="/video-tutorials/getting-started" element={<GettingStartedVideo />} />
                    <Route path="/video-tutorials/example-fragments" element={<ExampleFragments />} />
                  </Routes>
                </div>
                <Outline />
              </main>
            </div>
            <Footer />
            <SearchModal isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
          </div>
        } />
      </Routes>
    </Router>
  )
}

export default App
